import { API_URL } from "../config";
import { getToken, logout } from "./authHelper";
import { isImpersonating, restoreAdminSession } from "./impersonation";

const API_BASE_URL = API_URL || "https://api.socialyorix.com";

export const apiRequest = async (path, options = {}) => {
  const headers = { ...(options.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.body && !(typeof FormData !== "undefined" && options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  } catch (requestError) {
    if (requestError.name === "AbortError") throw requestError;
    const error = new Error(`Unable to reach the API server at ${API_BASE_URL}. Check that the backend is running and try again.`);
    error.cause = requestError;
    throw error;
  }
  if (response.status === 204) return null;
  const data = await response.json().catch(() => ({}));
  if (response.status === 401 && token && !path.startsWith("/api/auth/login")) {
    // An expired or revoked support session returns the admin to their own session instead of signing out.
    if (isImpersonating() && restoreAdminSession()) window.dispatchEvent(new Event("auth:impersonation-ended"));
    else {
      logout();
      window.dispatchEvent(new Event("auth:expired"));
    }
  }
  if (!response.ok) {
    const error = new Error(data.message || `Request failed (${response.status})`);
    error.status = response.status;
    error.data = data;
    // Plan limits are enforced by the API; the workspace layout listens for this to offer an upgrade.
    if (typeof data.code === "string" && data.code.startsWith("PLAN_")) {
      window.dispatchEvent(new CustomEvent("plan:limit", { detail: { code: data.code, message: error.message, limitKey: data.limitKey || null } }));
    }
    // The API refuses workspace requests until onboarding is finished; the workspace sends the user back to it.
    if (data.code === "ONBOARDING_REQUIRED") window.dispatchEvent(new Event("auth:onboarding-required"));
    throw error;
  }
  return data;
};

export const apiUrl = (path) => /^https?:\/\//i.test(path) ? path : `${API_BASE_URL}${path}`;